import { BaseContainerModel } from '../../base-container.model';
import { bl_dgmkt_campaign_hdr_RowClass } from '../../../dbschema/bl_dgmkt_campaign_hdr.model';

export class DgMktCampaignHeaderContainerModel extends BaseContainerModel {
  bl_dgmkt_campaign_hdr: bl_dgmkt_campaign_hdr_RowClass =
    new bl_dgmkt_campaign_hdr_RowClass();
}
